import service from "../service";
// import { getApiBaseUrl } from "../config";

export default {
    async getNoticeList() {
        const response = await service.get(`/api/notice/get_all_notice`);
        return response;
    },

    async addNotice(notice) {
        const response = await service.post(`/api/notice/add_notice`, notice);
        return response;
    },

    async updateNotice(notice) {
        const response = await service.patch(
            `/api/notice/update_notice`,
            notice
        );
        return response;
    },

    async deleteNotice(notice_id) {
        const response = await service.delete(
            `/api/notice/delete/${notice_id}`
        );
        return response;
    },
};
